<template>
  <div class="home">
<section id="slider" class="slider-element main-bg"
             :style="`background: linear-gradient(to right, rgba(0,0,0, 0.4) 20%, transparent 100%), url(${require('@/assets/images/bgMain.jpg')}) no-repeat center center / cover;`"
    >
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6 col-md-6 dark mb-5 mb-md-0 py-5 text-start">
            <h2 class="display-4 reveal" style="font-weight: 600; --delay: 0ms;">{{ $t("Expert Care") }}<br>{{ $t("at Your Doorstep") }}</h2>

            <p class="mb-5 lead text-white op-07 reveal" style="--delay: 120ms;">
              {{
                $t("Connect with licensed nurses, physiotherapists, and doctors through our app and receive personalised medical care in the comfort of your home.")
              }}
            </p>

            <a href="#whatWeDo"
               class="button button-xlarge button-white button-light fw-normal text-transform-none ls-0 btn-cta reveal"
               style="--delay: 240ms;"
            >{{ $t("Contact Us") }}</a>
          </div>

          <div class="col-md-6 d-flex align-self-end align-items-center align-items-lg-end col-form">
            <div class="card bg-white border-0 w-100 shadow p-3 rounded-0 reveal" style="--delay: 300ms;">
              <div class="card-body">
                <h3 class="mb-0 text-start fw-bold">{{ $t("Request a Homecare Visit") }}</h3>

                <div class="line line-sm mt-3"></div>

                <div class="widget mt-0 form-widget" data-alert-type="inline">
                  <div class="form-result"></div>

                  <form class="mb-0">
                    <div class="ps-lg-4">
                      <div class="row">
                        <div class="col-lg-12 text-start">
                          <label class="form-label fw-bold">{{ $t("Select healthcare professional") }}</label>
                          <div class="form-group has-label" :class="{'has-danger': v$.model.employeeType.$error }">
                            <div v-for="type in employeeTypes" :key="type" class="form-check-inline">
                              <input :id="type" v-model="model.employeeType" class="form-check-input" type="radio" :name="type" :value="type" />
                              <label class="form-check-label ps-1" :for="type" :title="type" aria-hidden="true">{{ $t(type) }}</label>
                            </div>
                            <div v-if="v$.model.employeeType.$invalid" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{
                                v$.model.employeeType.$errors.map(err => {
                                  return err.$message
                                })[0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div v-if="model.employeeType && model.employeeType !== 'doctor' && model.employeeType !== 'physiotherapist'" class="col-lg-12 text-start">
                          <label class="form-label fw-bold">{{ $t("What kind of support do you need?") }}</label>
                          <div class="form-group has-label" :class="{'has-danger': v$.model.serviceType.$error }">
                            <div v-for="type in serviceTypes" :key="type" class="form-check-inline">
                              <input :id="type" v-model="model.serviceType" class="form-check-input" type="radio" :name="type" :value="type" />
                              <label class="form-check-label ps-1" :for="type" :title="type" aria-hidden="true">{{ $t(type) }}</label>
                            </div>
                            <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{
                                v$.model.serviceType.$errors.map(err => {
                                  return err.$message
                                })[0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ps-lg-4">
                      <div class="row">
                        <div v-if="['shift', 'service'].includes(model.serviceType)" class="col-lg-12">
                          <div class="form-group has-label" :class="{'has-danger': v$.model.shiftDate.$error }">
                            <label class="form-label fw-bold">{{ $t("When?") }}</label>
                            <VueDatePicker
                                v-model="model.shiftDate"
                                :locale="$store.state.locale"
                                auto-apply
                                format="dd/MM/yyyy"
                                :flow="['calendar']"
                                :min-date="new Date()"
                                :placeholder="$t('Choose your date')"
                            ></VueDatePicker>
                            <div v-if="v$.model.shiftDate.$invalid" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{
                                v$.model.shiftDate.$errors.map(err => {
                                  return err.$message
                                })[0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
<!--                        <div v-if="['service'].includes(model.serviceType) && model.shiftDate" class="col-lg-12">-->
<!--                          <div class="form-group has-label">-->
<!--                            <label class="form-label fw-bold">{{ $t("Preferred time") }}</label>-->
<!--                            <div class="row">-->
<!--                              <div class="col-6">-->
<!--                                <VueDatePicker-->
<!--                                    v-model="model.startTime"-->
<!--                                    :locale="$store.state.locale"-->
<!--                                    :select-text="$t('Select')"-->
<!--                                    :cancel-text="$t('Cancel')"-->
<!--                                    :start-time="{ hours: 10, minutes: 0 }"-->
<!--                                    minutes-increment="10"-->
<!--                                    minutes-grid-increment="10"-->
<!--                                    format="HH:mm"-->
<!--                                    time-picker-->
<!--                                    :flow="['time']"-->
<!--                                    :placeholder="$t('From')"-->
<!--                                ></VueDatePicker>-->
<!--                                <div v-if="v$.model.startTime.$invalid" class="text-danger invalid-feedback"-->
<!--                                     style="display: block;"-->
<!--                                >-->
<!--                                  {{-->
<!--                                    v$.model.startTime.$errors.map(err => {-->
<!--                                      return err.$message-->
<!--                                    })[0]-->
<!--                                  }}-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              <div class="col-6">-->
<!--                                <VueDatePicker-->
<!--                                    v-model="model.endTime"-->
<!--                                    :locale="$store.state.locale"-->
<!--                                    :select-text="$t('Select')"-->
<!--                                    :cancel-text="$t('Cancel')"-->
<!--                                    :start-time="{ hours: 10, minutes: 0 }"-->
<!--                                    minutes-increment="10"-->
<!--                                    time-picker-->
<!--                                    minutes-grid-increment="10"-->
<!--                                    format="HH:mm"-->
<!--                                    :flow="['time']"-->
<!--                                    :placeholder="$t('To')"-->
<!--                                ></VueDatePicker>-->
<!--                                <div v-if="v$.model.endTime.$invalid" class="text-danger invalid-feedback"-->
<!--                                     style="display: block;"-->
<!--                                >-->
<!--                                  {{-->
<!--                                    v$.model.endTime.$errors.map(err => {-->
<!--                                      return err.$message-->
<!--                                    })[0]-->
<!--                                  }}-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->

                        <div v-if="model.serviceType === 'service' && model.shiftDate" class="col-lg-12 text-start">
                          <label class="form-label fw-bold">{{ $t("Select the services required:") }}
                            <span v-if="requestCost">{{ '€' + model.cost.totalCost/100 }}</span>
                          </label>
                          <div class="form-group has-label">
                            <div v-for="service in services" :key="'s'+service.id" class="form-check">
                              <input :id="'s'+service.id" v-model="model.services" class="form-check-input" type="checkbox" :name="getTranslation(service.name, $store.state.locale)" :value="service" />
                              <label class="form-check-label ps-1" :for="'s'+service.id" :title="getTranslation(service.name, $store.state.locale)" aria-hidden="true">
                                {{ getTranslation(service.name, $store.state.locale) }}
                              </label>

                              <tooltip :tooltip-text="getTranslation(service.description, $store.state.locale)">
                                <i class="fa fa-info-circle ps-2"></i>
                              </tooltip>
                            </div>
                            <div v-if="model.services.length === 0 && v$.model.$dirty" class="text-danger invalid-feedback"
                                 style="display: block;"
                            >
                              {{ $t("You need to select at least one Service") }}
                            </div>
                          </div>
                        </div>
                        <div v-if="model.serviceType === 'shift' && model.shiftDate != null" class="col-lg-12 text-start">
                            <label class="form-label fw-bold">{{ $t("What type of live-in care you want?") }}</label>
                            <div class="form-group has-label" :class="{'has-danger': v$.model.shiftService.$error }">
                              <div v-for="service in services" :key="service.id" class="form-check-inline">
                                <input :id="service.id" v-model="model.shiftService" class="form-check-input" type="radio" :name="service.id" :value="service" />
                                <label class="form-check-label ps-1" :for="service.id" :title="getTranslation(service.name, $store.state.locale)" aria-hidden="true">
                                  {{ getTranslation(service.name, $store.state.locale) }}
                                  <tooltip :tooltip-text="getTranslation(service.description, $store.state.locale)">
                                    <i class="fa fa-info-circle ps-2"></i>
                                  </tooltip>
                                </label>
                              </div>
                              <div v-if="v$.model.shiftService.$invalid" class="text-danger invalid-feedback"
                                   style="display: block;"
                              >
                                {{
                                  v$.model.shiftService.$errors.map(err => {
                                    return err.$message
                                  })[0]
                                }}
                              </div>
                            </div>
                        </div>
                        <div v-if="model.serviceType === 'shift' && model.shiftDate != null && model.shiftService != null" class="col-lg-12 text-start live-in-time-select">
                        <div class="form-group has-label" :class="{'has-danger': v$.model.shiftSlot.$error }">
                            <label class="form-label fw-bold">{{ $t("Please select your preferred live-in care time:") }}</label>
                            <multiselect
                                v-model="model.shiftSlot"
                                :show-labels="false"
                                :placeholder="$t('Select time slot')"
                                :options="model.shiftService.timeSlots" :multiple="false"
                            >
                              <template #singleLabel="{ option }">
                                {{ option.startTime }} - {{ option.endTime }} ({{ option.priceInCents / 100 + '€' }})
                              </template>
                              <template #option="props">
                                {{ props.option.startTime }} - {{ props.option.endTime }}
                                ({{ props.option.priceInCents / 100 + '€' }})
                              </template>
                            </multiselect>
                            <!--                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                            <!--                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}-->
                            <!--                        </div>-->
                          </div>
                        </div>
                        <display-label
                            v-if="showCost"
                            label="Total cost:"
                            :value="model.cost.totalCost == null ? '€' : '€' + model.cost.totalCost/100"
                        ></display-label>
                      </div>
                    </div>
                    <div class="mt-3">
                      <button type="button" class="button button-xlarge w-100 fw-normal text-transform-none ls-0 ms-0 mt-2" @click="submitForm">
                        {{ $t("Submit Request") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="whychooseus" class="section section-lg section-shaped my-0">
      <div class="shape shape-style-3 bg-gradient-primary shape-skew">
        <span></span><span></span><span></span><span></span>
</div>
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h1 class=" fw-bold text-white reveal" style="--delay: 0ms;">{{ $t("Why Choose Us?") }}</h1>
            <p class="lead text-white">
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5 justify-content-center">
          <div class="col-lg-4 p-3 box reveal" style="--delay: 0ms;">
            <div class="icon icon-shape icon-lg bg-white shadow text-white">
              <i
                  class="fa fa-money-bill-trend-up text-primary"
              ></i>
            </div>
            <h5 class="text-white mt-3 fw-bold">{{ $t("Healthcare That Comes to You") }}</h5>
            <p class="text-white mt-3">
              {{
                $t("From nursing care and physiotherapy to medical consultations, Heed brings professional healthcare directly to your home. It’s personalised, reliable, and delivered with care.")
              }}
            </p>
          </div>
          <div class="col-lg-4 p-3 box reveal" style="--delay: 140ms;">
            <div class="icon icon-shape icon-lg bg-white shadow text-white">
              <i class="fa fa-money-bill text-primary"></i>
            </div>
            <h5 class="text-white mt-3 fw-bold">{{ $t("Qualified Experts You Can Trust") }}</h5>
            <p class="text-white mt-3">
{{
                $t("Our network includes fully licensed nurses, doctors, and physiotherapists with proven experience. Every provider is handpicked to ensure quality, safety, and professionalism.")
              }}
</p>
          </div>
          <div class="col-lg-4 p-3 box reveal" style="--delay: 280ms;">
            <div class="icon icon-shape icon-lg bg-white shadow text-white">
              <i
                  class="fa fa-user-clock text-primary"
              ></i>
            </div>
            <h5 class="text-white mt-3 fw-bold">{{ $t("Fast, Easy, and Hassle-Free") }}</h5>
            <p class="text-white mt-3">
{{
                $t("Requesting care is simple. Just register through our app, tell us what you need, and get matched with a trusted professional. No delays and no stress.")
              }}
</p>
          </div>
        </div>
      </div>
      <div class="separator pb-lg-0 pb-5">
        <svg viewBox="0 -100 1600 185" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"
             style="display: block;"
>
          <!-- Hexagon shapes creating the honeycomb pattern -->
          <defs>
            <pattern id="hexPattern" patternUnits="userSpaceOnUse" width="100" height="86.6"
                     patternTransform="scale(1)"
>
              <!-- Single Hexagon -->
              <polygon points="50,0 100,25 100,61.6 50,86.6 0,61.6 0,25" style="fill:rgba(255,255,255,0.27);" />
            </pattern>
          </defs>
          <!-- Background fill with the honeycomb pattern -->
          <!--          <rect width="1600" height="200" fill="url(#hexPattern)" />-->
        </svg>
      </div>
    </section>
    <section class="section section-lg pt-0 pb-0 mt-0 mb-0">
      <div class="">
        <card
            no-body
            shadow-size="lg"
            class="border-0"
            style="border-radius: 0;"
        >
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-4 col-md-7 offset-lg-1 mb-5 mb-lg-0">
                <h3 class="text-dark text-n-right mb-0 reveal" style="--delay: 0ms;">{{ $t("Care, Comfort") }} <br>&amp; {{ $t("Control") }}</h3>

                <div id="oc-testi"
                     class="owl-carousel testimonials-carousel carousel-widget mt-3 owl-loaded owl-drag with-carousel-dots"
                     data-margin="0" data-items="1" data-pagi="true" data-nav="false"
                >
                  <div class="owl-stage-outer">
                    <div class="owl-stage"
                         style="transform: translate3d(0px, 0px, 0px); transition: all; width: 1248px;"
                    >
                      <div class="owl-item active" style="width: 416px;">
                        <div class="oc-item text-md-end">
                          <h4 class="fw-normal text-black text-size-sm" style="line-height: 1.5;">
                            {{ $t("At Heed, your home becomes a place of healing.You rest in your own bed, enjoy your daily routine, and stay connected to work or family — while we handle the care.Whether it's morning medication, midday therapy, or an evening nurse visit, Heed adapts to your life, not the other way around.") }}
</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-5 col-md-5 ps-lg-4">
                <img class="reveal" style="--delay: 180ms;" :src="require('@/assets/images/careImage.jpg')" alt="Image">
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>

    <div class="section text-center studio-tab mb-0 mt-0" style="background-color: #960e451f">
      <div class="container mx-auto" style="max-width: 1800px">
        <div class="heading-block border-0">
          <h3 class="text-dark reveal" style="--delay: 0ms;">{{ $t("Check out your Comforts") }}</h3>

          <span class="reveal" style="--delay: 120ms;">{{ $t("Thoughtful care tailored to you, because home is where healing begins.") }}</span>
        </div>


        <div class="row justify-content-between text-start">
          <!-- Feature Box

                            ============================================= -->


          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 0ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Home - Based Care") }}</h4>

            <p class="text-muted">
              {{ $t("Receive high - quality medical support in the comfort of your own home.") }}
            </p>
          </div>

          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 120ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Certified Professionals") }}</h4>

            <p class="text-muted">
              {{ $t("Every provider is licensed, carefully vetted, and experienced in home healthcare.") }}
            </p>
          </div>
          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 240ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Easy Booking via App") }}</h4>

            <p class="text-muted">
              {{ $t("Schedule visits, manage appointments, and get updates — all from your phone.") }}
</p>
          </div>
          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 360ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Flexible Scheduling") }}</h4>

            <p class="text-muted">
              {{ $t("Choose the time that works best for your lifestyle, including evenings and weekends.") }}
</p>
          </div>

          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 480ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Stress - Free Experience") }}</h4>

            <p class="text-muted">
              {{ $t("No commuting, no waiting rooms, no disruptions to your day.") }}
            </p>
          </div>
          <div class="col-lg-4 col-md-6 mb-4 reveal" style="--delay: 600ms;">
            <h4 class="mb-3 fw-bold">{{ $t("Compassionate Approach") }}</h4>

            <p class="text-muted">
              {{ $t("Our team combines clinical skill with empathy, respect, and genuine care.") }}
            </p>
          </div>
        </div>
      </div>
    </div>
        <section class="section section-lg pt-0 pb-0 m-0">
      <card
          no-body
          shadow-size="lg"
          class="border-0"
          style="border-radius: 0;"
      >
        <div class="">
          <div class="row align-items-center justify-content-md-center">
            <div class="col-md-9 text-md-start reveal" style="--delay: 0ms;">
              <div class="row align-items-center">
                <div class="col-lg-12">
                  <download-app
                      app-store-link="https://apps.apple.com/cy/app/heed-cy/id6743553511"
                      play-store-link="https://play.google.com/store/apps/details?id=cy.com.heed&hl=en"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </card>
    </section>

    <contact-us></contact-us>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import {helpers, required, requiredIf} from "@vuelidate/validators"
import Card from "@/components/Card"
import ContactUs from "@/views/ContactUs"
import {getAnalytics, logEvent} from "firebase/analytics"
import DownloadApp from "@/components/DownloadApp.vue"
import VueDatePicker from "@vuepic/vue-datepicker"
import Tooltip from "@/components/Tooltip.vue"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import DisplayLabel from "@/components/DisplayLabel.vue"
import {calculateRequestCost} from "@/helpers/shiftCostCalculator"

export default {
  name: "home-iew",
  components: {
    DisplayLabel,
    DownloadApp, 
    ContactUs, 
    Card, 
    VueDatePicker,
    Tooltip
  },
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      availableRoutes: [],
      clientConfigs: null,
      positions: [],
      employeeTypes: ["nurse", "doctor"],
      serviceTypes: ["service", "shift"],
      services: [],
      requestCost: false,
      model: {
        employeeType: null,
        serviceType: null,
        shiftDate: null,
        startTime: null,
        endTime: null,
        shiftService: null,
        shiftSlot: null,
        services: [],
        cost: {
          totalCost: 0
        }
      }
    }
  },
  computed: {
    showCost() {
      if (this.model.serviceType == null ||
          (this.model.serviceType === "shift" && (this.model.shiftService == null || this.model.shiftSlot == null)) ||
          this.model.serviceType === "service" && this.model.services.length === 0 ||
      this.model.shiftDate == null) {
        return false
      }

      console.log("calculateRequestCost", this.model)
      // this.v$.$touch()
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.model.cost = calculateRequestCost(this.clientConfigs, this.model.serviceType === "shift" ? [{timeSlot: this.model.shiftSlot}] : this.model.services ?? [], this.model.serviceType, this.model.employeeType)

      return true
    }
  },
  watch: {
    "model.serviceType": function (newValue) {
      console.log("model.serviceType", newValue)
      if (newValue == null) {
        return
      }

      this.model.shiftSlot = null
      this.getServices(newValue, this.model.employeeType)
      this.getSettings()
    },
    "model.employeeType": function (newValue) {
      if (newValue == null) {
        return
      }
      if (newValue === "doctor" || newValue === "physiotherapist") {
        this.model.serviceType = "service"
      }
      this.getServices(this.model.serviceType, newValue)
    },
    "model.shiftDate": function (newValue) {
      console.log("model.shiftDate newValue", newValue)

      if (newValue !== null && newValue < new Date()) {
        this.getEmployees()
      }

      if (this.model.endDate == null) {
        this.model.endDate = this.$moment(newValue).add("8", "hours").toDate()
      }
    },
    "model.clientId": async function (client) {
      console.log("model.clientId", client)
      if (client) {
        await this.getSettings(client.id)
      }
    },
  },
  beforeUnmount() {
    if (this._revealObserver) {
      this._revealObserver.disconnect()
      this._revealObserver = null
    }
  },
  validations() {
    return {
      model: {
        employeeType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        serviceType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        shiftDate: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        // startTime: {
        //   required: helpers.withMessage(this.$t("Value is required"), required)
        // },
        // endTime: {
        //   required: helpers.withMessage(this.$t("Value is required"), required)
        // },
        shiftSlot: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
        shiftService: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
      }
    }
  },
  async mounted() {
    // Reveal-on-scroll observer for subtle entrance animations
    const root = this.$el
    const els = root.querySelectorAll(".reveal")
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (!els.length) return
    const onIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-visible")
          observer.unobserve(entry.target)
        }
      })
    }
    this._revealObserver = prefersReduced ? null : new IntersectionObserver(onIntersect, { threshold: 0.15 })
    els.forEach(el => {
      if (this._revealObserver) this._revealObserver.observe(el)
      else el.classList.add("reveal-visible")
    })
    const analytics = getAnalytics()
    logEvent(analytics, "page_view", {
      page_title: this.$route.name
    })
    const self = this
    setTimeout(function () {
      self.$store.dispatch("refreshClaims")
    }, 3 * 1000) // time in milliseconds
  },
  methods: {
    async getSettings() {

      if (this.clientConfigs == null) {
        this.clientConfigs = await this.$store.dispatch("fetchSettings")
      }

      console.log("this.clientConfigs", this.clientConfigs)
    },
    normalizeGreek(text) {
      return text
    },
    getTranslation(obj, locale) {
      if (obj && obj[locale]) {
        return obj[locale]
      } else if (obj && obj.en) {
        return obj.en
      }
      return ""
    },
    async getServices(serviceType, employeeType) {
      if (serviceType == null || employeeType == null) {
        return
      }
      this.model.services = []
      this.services = []
      this.services = await this.$store.dispatch("fetchAllServices", {type: serviceType, employeeType: employeeType})
      console.log("servicessssss", this.services)


      if (this.services.length === 1 && this.model.services.length === 0) {
        this.model.services.push(this.services[0])
      }
    },
    submitForm() {
      this.v$.model.$touch()
      if (this.v$.model.$invalid) {
        console.log("erros", this.v$.model.$errors)
        return
      }
      // Handle form submission
      console.log("Form submitted", this.model)
      // Redirect to login or registration if needed
      localStorage.setItem("pendingRequestModel", JSON.stringify(this.model))
      if (this.$store.state.user.claims) {
        this.$router.push("/requests/new")
      } else {
        this.$router.push("/register-client")
      }
    },
    submitRequest() {
      // Implement the actual request submission logic
      FirebaseFunctionsHelper.callFunction("create-request", this.model)
        .then((result) => {
          if (result && result.success) {
            this.$router.push({ name: "requests" })
          }
        })
        .catch((error) => {
          console.error("Error submitting request:", error)
        })
    },
  },
}
</script>
<style scoped>

#slider {
  position: relative;
  z-index: 3;
  overflow: visible;
}

#whychooseus {
  position: relative;
  z-index: 1;
}

.col-form,
.col-form .card,
.col-form .card-body,
.form-widget,
.live-in-time-select,
.live-in-time-select .form-group {
  overflow: visible;
}

.live-in-time-select {
  position: relative;
  z-index: 50;
}

.live-in-time-select :deep(.multiselect) {
  position: relative;
  z-index: 51;
}

.live-in-time-select :deep(.multiselect__content-wrapper) {
  z-index: 60;
}

@media (min-width: 1200px) {
  .container[data-v-fae5bece] {
    width: 1320px !important;
  }
}


.search-box input {
  box-shadow: none !important;
  border: none;
  text-align: left;
  padding-left: 0;
}

@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1030px;
  }
}

body {
  background: #0080804a;
}

.table thead th {
  padding: 15px;
  font-size: 15px;
}

th.text-start {
  font-size: 15px;
}

.separator {
  bottom: -4px;
  left: 0;
  overflow: hidden;
  position: absolute;

  width: 100%;
}

@media screen and (max-width: 767px) {
  .section-one {
    padding: 130px 0 190px;
  }

  .separator {
    bottom: -110px;

    .separator__svg {
      left: -20%;
      position: relative;
      transform: rotate(15deg);
      width: 140%;
    }
  }
}

.section-shaped .shape {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.section-shaped {
  margin: 180px 0;
  position: relative;
}

.text-transform-none:hover {
  text-decoration: none !important;
}

/* Subtle, performant entrance animations */
.reveal {
  opacity: 0;
  transform: translateY(18px);
  transition: opacity 600ms ease, transform 600ms ease;
  transition-delay: var(--delay, 0ms);
  will-change: opacity, transform;
}
.reveal-visible {
  opacity: 1;
  transform: none;
}

/* CTA micro-interaction */
.btn-cta {
  transition: transform 200ms ease, box-shadow 200ms ease;
}
.btn-cta:hover {
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

/* Card polish */
.card.bg-white {
  transition: transform 220ms ease, box-shadow 220ms ease;
}
.card.bg-white:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 40px rgba(0,0,0,.12);
}

/* Floating icons in Why Choose Us */
.box .icon {
  transition: transform 400ms ease;
  animation: floatY 6s ease-in-out infinite;
}
.box:hover .icon {
  transform: translateY(-2px) scale(1.03);
}
@keyframes floatY {
  0% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}

/* Animate background shape spans subtly */
.section-shaped .shape span {
  position: absolute;
  display: block;
  background: rgba(255,255,255,0.06);
  border-radius: 50%;
  filter: blur(0.2px);
}
.section-shaped .shape span:nth-child(1) { width: 100px; height: 100px; left: 5%; top: 10%; animation: blob 18s ease-in-out infinite; }
.section-shaped .shape span:nth-child(2) { width: 70px; height: 70px; left: 25%; top: 40%; animation: blob 22s ease-in-out -4s infinite; }
.section-shaped .shape span:nth-child(3) { width: 120px; height: 120px; right: 20%; top: 20%; animation: blob 20s ease-in-out -8s infinite; }
.section-shaped .shape span:nth-child(4) { width: 80px; height: 80px; right: 10%; bottom: 15%; animation: blob 24s ease-in-out -2s infinite; }
@keyframes blob {
  0%, 100% { transform: translate3d(0,0,0) scale(1); }
  33% { transform: translate3d(10px, -8px, 0) scale(1.04); }
  66% { transform: translate3d(-12px, 6px, 0) scale(0.98); }
}

/* Reduce motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; transition: none; }
  .box .icon, .section-shaped .shape span { animation: none !important; }
  .btn-cta, .card.bg-white { transition: none; }
}

</style>
